import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { NgxSpinnerService } from "ngx-spinner";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOOrderType } from "src/app/shared/models/oo-order-type";
import { OOPriceLevel } from "src/app/shared/models/oo-price-level";

@Component({
	selector: "app-price-level-setup",
	templateUrl: "./price-level-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class PriceLevelSetupComponent implements OnInit {
	changesToSave: boolean = false;

	loaded: boolean = false;

	moment: any = moment;

	newRecord: boolean = false;

	priceLevels: OOPriceLevel[];
	priceLevelSelected: OOPriceLevel;

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private localStorage: LocalDataStoreService,
		private spinner: NgxSpinnerService,
		private userService: UserService,
		public imgCrop: ImageCropperService,
		public venueService: OOVenueService
	) {}

	ngOnInit(): void {
		this.venueService.subscriptionVenue.subscribe((venue) => {
			if (venue && venue.key) {
				this.load();
			}
		});
		this.load();
	}

	async load() {
		this.priceLevelsGet(this.venueService.subscriptionVenue.value.key);
	}

	async priceLevelsGet(venueKey) {
		const resp = await this.focuslink.priceLevelGet(venueKey);
		this.priceLevels = resp.map((i) => {
			return new OOOrderType(i);
		});
	}

	async priceLevelSave(rec: OOPriceLevel) {
		await this.focuslink.priceLevelPost(this.venueService.subscriptionVenue.value.key, rec);
	}
}
